import { CORE_SERVER } from "../config";

export const uploadFile = async (file: File): Promise<{ success: boolean; imageId?: string }> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('Model', JSON.stringify({
      config: 'Stahls',
      ident: {
        superuser: false,
        sessionid: 'dc852e74-d3f0-42e8-95eb-4f3dbc6c16cc',
      },
    }));
  
    try {
      const response = await fetch(`${CORE_SERVER}/core2/userfiles/upload`, {
        method: 'POST',
        body: formData,
      });
      const json = await response.json();
      return json.Success ? { success: true, imageId: json.Model.Id } : { success: false };
    } catch {
      return { success: false };
    }
  };
  